import {createStore, applyMiddleware, combineReducers} from 'redux';
import {composeWithDevTools} from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import homePageReducer from './reducers/homePageReducer';
import laptopQuizPageReducer from './reducers/laptopQuizPageReducer';
import searchPageReducer from './reducers/searchPageReducer';
import leftMenuSidebarReducer from './reducers/leftMenuSidebarReducer';

const reducer = combineReducers({
  homePage: homePageReducer,
  laptopQuizPage: laptopQuizPageReducer,
  searchPage: searchPageReducer,
  leftMenuSidebar: leftMenuSidebarReducer
});

export default createStore(
  reducer,
  composeWithDevTools(
    applyMiddleware(thunk)
  )
);


// WEBPACK FOOTER //
// ./src/store.js